module.exports = __webpack_public_path__ + "static/best-offers-80cb0531b48307aa206a0dbc87ff8273.jpg";